(function () {
    const validRegions = [
        'korea', 'china', 'southeast-asia', 'taiwan', 'west', 'india', 'europa', 'japan'
    ];

    function setRegion(region) {
        localStorage.setItem('region', region);
        document.cookie = `region=${region}; path=/; SameSite=Lax`;
    }

    const getRegionFromQuery = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const region = urlParams.get('region')?.toLowerCase();
        return validRegions.includes(region) ? region : null;
    };
    const getRegionFromLocalStorage = () => {
        const region = localStorage.getItem('region');
        return validRegions.includes(region) ? region : null;
    };
    const getRegionFromCookie = () => {
        const match = document.cookie.match(/region=([a-z-]+)/i);
        return match && validRegions.includes(match[1].toLowerCase()) ? match[1].toLowerCase() : null;
    };

    const region =
        getRegionFromQuery() ||
        getRegionFromLocalStorage() ||
        getRegionFromCookie() ||
        'korea';

    setRegion(region);

    window.getCurrentRegion = function() {
        return document.body.getAttribute('data-region') || 'korea';
    };
    window.setRegion = setRegion;

    // Listen for browser navigation and reload if region changes
    window.addEventListener('popstate', function() {
        const region = getRegionFromQuery();
        if (region) {
            window.setRegion(region);
            location.reload();
        }
    });
})(); 